import { FILTER_KEYS } from '@app-store'
import { useAppSelector } from '../../utils/agent.store'

const WorkflowBreadCrumbs = () => {
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const name_of_organization = useAppSelector(
    (state) => state.authUser.selectedClientTenant?.name_of_organization
  )

  return workflowDefinition?.definition?.workFlowName ? `${workflowDefinition?.definition?.workFlowName.replace(FILTER_KEYS.DO_NOT_USE, '').replace('-', '')} - ${name_of_organization}` : `${name_of_organization} - Workflow`
}

export default WorkflowBreadCrumbs
